var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "indexMain" },
    [
      _c("Search", { on: { toSsearch: _vm.toSsearch } }),
      _vm._v(" "),
      _c("div", { staticClass: "m" }, [
        _c(
          "div",
          {
            staticClass: "tit",
            on: {
              click: function ($event) {
                return _vm.$router.push({ path: "/majorSource" })
              },
            },
          },
          [_vm._v("专业资源库")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "courseL" }, [
          _vm.majorSource.length > 0
            ? _c(
                "div",
                { staticClass: "list" },
                _vm._l(_vm.majorSource, function (item) {
                  return _c(
                    "div",
                    { staticClass: "listItem" },
                    [_c("CourseItem", { attrs: { type: 1, item: item } })],
                    1
                  )
                }),
                0
              )
            : _c(
                "div",
                {
                  staticStyle: { "margin-top": "50px", "text-align": "center" },
                },
                [_c("img", { attrs: { src: _vm.$store.getters.noData } })]
              ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tit",
            on: {
              click: function ($event) {
                return _vm.$router.push({ path: "/onlineCourse" })
              },
            },
          },
          [_vm._v("精品在线课")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "courseL" }, [
          _vm.onlineCourse.length > 0
            ? _c(
                "div",
                { staticClass: "list" },
                _vm._l(_vm.onlineCourse, function (item) {
                  return _c(
                    "div",
                    { staticClass: "listItem" },
                    [_c("CourseItem", { attrs: { type: 2, item: item } })],
                    1
                  )
                }),
                0
              )
            : _c(
                "div",
                {
                  staticStyle: { "margin-top": "50px", "text-align": "center" },
                },
                [_c("img", { attrs: { src: _vm.$store.getters.noData } })]
              ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tit",
            on: {
              click: function ($event) {
                return _vm.$router.push({ path: "/fictitiousCourse" })
              },
            },
          },
          [_vm._v("虚拟仿真课")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "courseL" }, [
          _vm.fictitiousCourse.length > 0
            ? _c(
                "div",
                { staticClass: "list" },
                _vm._l(_vm.fictitiousCourse, function (item) {
                  return _c(
                    "div",
                    { staticClass: "listItem" },
                    [_c("CourseItem", { attrs: { type: 4, item: item } })],
                    1
                  )
                }),
                0
              )
            : _c(
                "div",
                {
                  staticStyle: { "margin-top": "50px", "text-align": "center" },
                },
                [_c("img", { attrs: { src: _vm.$store.getters.noData } })]
              ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tit",
            on: {
              click: function ($event) {
                return _vm.$router.push({ path: "/teachingMaterial" })
              },
            },
          },
          [_vm._v("新形态教材")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "courseL" }, [
          _vm.teachingMaterial.length > 0
            ? _c(
                "div",
                { staticClass: "list" },
                _vm._l(_vm.teachingMaterial, function (item) {
                  return _c(
                    "div",
                    { staticClass: "listItem2" },
                    [_c("CourseItem", { attrs: { type: 5, item: item } })],
                    1
                  )
                }),
                0
              )
            : _c(
                "div",
                {
                  staticStyle: { "margin-top": "50px", "text-align": "center" },
                },
                [_c("img", { attrs: { src: _vm.$store.getters.noData } })]
              ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }